export enum UsersViewType {
    FOLLOWERS = "FOLLOWERS",
    FOLLOWED = "FOLLOWED",
    LIKES = "LIKES",
    REQUESTS = "REQUESTS"
}